<template>
  <main>
    <div class="home_btn" @click="entoSouhuo">
        <i class='iconfont icon-shouye'></i>
    </div>
  </main>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    entoSouhuo () {
      this.$router.push({
        name: 'souhuo'
      })
    }
  }
}
</script>

<style scoped>
  .home_btn{
        position: fixed;
        bottom:55px;
        right:15px;
        display: block;
        color:#fff;
        width:44px;
        height:44px;
        background: #555;
        opacity: 0.85;
        border-radius: 50%;
        box-sizing: border-box;
        text-align: center;
        line-height: 45px;
        z-index: 99;
    }
    .home_btn .iconfont{
        font-size: 20px;
    }
    .home_btn:hover{
        background-color: rgba(0, 0, 0, 0.1);
    }
</style>
